import {type WBFileData} from '../../../components/ImageCard/utils';
import type * as PanelTypes from '../../../state/views/panel/types';
import {type PartRefFromObjSchema} from '../../../state/views/types';
import {type RunSignature} from '../../../types/run';
import {type TileMediaSpec} from '../../MediaCard';

export type ModalData = {
  mediaPanelRef: PartRefFromObjSchema<PanelTypes.PanelObjSchema>;
  tileMediaSpec: TileMediaSpec;
  labels: any[];
  imageURL: string;
  originalPixelOffset: number;
  runSignature: RunSignature;
  fullScreenTitle: React.ReactNode;
  imageDimensions?: {width: number; height: number} | null;
  mediaKey: string;
  controls: any;
  boundingBoxData: WBFileData[];
};

export type MediaBrowserModalProps = {
  isOpen: boolean;
  modalData: ModalData | null;
  onClose: () => void;
  updateModalData?: (data: ModalData) => void;
};

// The source of the zoom action to keep track of in analytics
export enum ZoomSource {
  Keyboard = 'keyboard',
  Dropdown = 'dropdown',
}
